module.exports = function () {
    $(() => {
        // кнопка меню
        $('.top-menu_js').click(function () {
            $(this).toggleClass('click');
            $('.dropdown-menu').slideToggle(500);
            $('.header').toggleClass('open-menu');
            setTimeout(() => {
                $('.header__back-close').toggleClass('header__back-close_back');
            }, 200);
        });

        $('.header__nav-a').click(function () {
            $('.top-menu_js').toggleClass('click');
            $('.header').removeClass('open-menu');
            setTimeout(() => {
                $('.header__back-close').removeClass('header__back-close_back');
            }, 200);
        });

        $('.top-menu-close_js').click(function () {
            $('.top-menu_js').toggleClass('click');
            $('.header').removeClass('open-menu');
            setTimeout(() => {
                $('.header__back-close').removeClass('header__back-close_back');
            }, 200);
        });

        $('.header__nav-a').click(function () {
            $('.top-menu_js').removeClass('click');
            $('.header').removeClass('open-menu');
            $('.header__nav-li').removeClass('header__nav-li_active');
            $(this).parent().addClass('header__nav-li_active');
            setTimeout(() => {
                $('.header__back-close').removeClass('header__back-close_back');
            }, 200);
        });

        $('.footer__nav-a').click(function() {
            $('.header__nav-li').removeClass('header__nav-li_active');
            $('.header__nav-li a[href="'+$(this).attr('href')+'"]').parent().addClass('header__nav-li_active');
        });
    });
}



// WEBPACK FOOTER //
// resources/assets/src/js/layout.js